import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Insider } from "@faire/web/slate/icons/InsiderIcon";
import React from "react";
import { OTHER_NODES_LABEL } from "../../shared/other-node";
import { BenefitsIA } from "../instantAnswers/insiderMembership-benefits";
import { BrandDoesNotHaveInsiderFreeShippingIA } from "../instantAnswers/insiderMembership-brandDoesNotHaveInsiderFreeShipping";
import { CancelMembershipIA } from "../instantAnswers/insiderMembership-cancelMembership";
import { DidNotGetInsiderFreeDutiesIA } from "../instantAnswers/insiderMembership-didNotGetInsiderFreeDuties";
import { DidNotGetInsiderFreeShippingIA } from "../instantAnswers/insiderMembership-didNotGetInsiderFreeShipping";
import { HowToFindBrandsThatHaveInsiderFreeShippingIA } from "../instantAnswers/insiderMembership-howToFindBrandsThatHaveInsiderFreeShipping";
import { PauseMembershipIA } from "../instantAnswers/insiderMembership-pauseMembership";
import { ManageInsiderMembershipVisibilityFn } from "../visibilityFunctions/manageInsiderMembershipVisibilityFn";
export var useInsiderMembershipRetailerNodes = function useInsiderMembershipRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    InsiderMembership: {
      id: "InsiderMembership",
      label: strictLocalize({
        id: "MD/Heq",
        defaultMessage: [{
          "type": 0,
          "value": "Subscrição Insider"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Insider, {
        color: "teal"
      }),
      children: ["Benefits", "PauseMembership", "CancelMembership", "FreeDuties", "FreeShipping", "OtherInsiderMembership"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "lxYyPF",
        defaultMessage: [{
          "type": 0,
          "value": "Problema com a subscrição Insider"
        }]
      })
    },
    Benefits: {
      id: "Benefits",
      label: strictLocalize({
        id: "TRL3+t",
        defaultMessage: [{
          "type": 0,
          "value": "Benefícios"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      instantAnswer: BenefitsIA(strictLocalize),
      level: 2
    },
    PauseMembership: {
      id: "PauseMembership",
      label: strictLocalize({
        id: "cloO+b",
        defaultMessage: [{
          "type": 0,
          "value": "Suspender a minha subscrição"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      isNodeVisible: ManageInsiderMembershipVisibilityFn,
      instantAnswer: PauseMembershipIA(strictLocalize),
      level: 2
    },
    CancelMembership: {
      id: "CancelMembership",
      label: strictLocalize({
        id: "xQ2Ixr",
        defaultMessage: [{
          "type": 0,
          "value": "Cancelar subscrição"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      isNodeVisible: ManageInsiderMembershipVisibilityFn,
      instantAnswer: CancelMembershipIA(strictLocalize),
      level: 2
    },
    FreeDuties: {
      id: "FreeDuties",
      label: strictLocalize({
        id: "DzX128",
        defaultMessage: [{
          "type": 0,
          "value": "Direitos aduaneiros gratuitos"
        }]
      }),
      children: ["DidNotGetInsiderFreeDuties"],
      level: 2
    },
    FreeShipping: {
      id: "FreeShipping",
      label: strictLocalize({
        id: "6ztNJR",
        defaultMessage: [{
          "type": 0,
          "value": "Envio gratuito"
        }]
      }),
      children: ["DidNotGetInsiderFreeShipping", "BrandDoesNotHaveInsiderFreeShipping", "HowToFindBrandsThatHaveInsiderFreeShipping"],
      level: 2
    },
    OtherInsiderMembership: {
      id: "OtherInsiderMembership",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      level: 2
    },
    DidNotGetInsiderFreeDuties: {
      id: "DidNotGetInsiderFreeDuties",
      label: strictLocalize({
        id: "bqLnMQ",
        defaultMessage: [{
          "type": 0,
          "value": "Não obtive direitos aduaneiros gratuitos com Insider numa encomenda"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      instantAnswer: DidNotGetInsiderFreeDutiesIA(strictLocalize),
      level: 3
    },
    DidNotGetInsiderFreeShipping: {
      id: "DidNotGetInsiderFreeShipping",
      label: strictLocalize({
        id: "zardre",
        defaultMessage: [{
          "type": 0,
          "value": "Não recebi envio gratuito com Insider numa encomenda"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      instantAnswer: DidNotGetInsiderFreeShippingIA(strictLocalize),
      level: 3
    },
    BrandDoesNotHaveInsiderFreeShipping: {
      id: "BrandDoesNotHaveInsiderFreeShipping",
      label: strictLocalize({
        id: "d0cYAB",
        defaultMessage: [{
          "type": 0,
          "value": "Uma marca já não tem envio gratuito com Insider"
        }]
      }),
      instantAnswer: BrandDoesNotHaveInsiderFreeShippingIA(strictLocalize),
      level: 3
    },
    HowToFindBrandsThatHaveInsiderFreeShipping: {
      id: "HowToFindBrandsThatHaveInsiderFreeShipping",
      label: strictLocalize({
        id: "uTOLef",
        defaultMessage: [{
          "type": 0,
          "value": "Como posso encontrar marcas com envio gratuito com Insider?"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      instantAnswer: HowToFindBrandsThatHaveInsiderFreeShippingIA(strictLocalize),
      level: 3
    }
  };
};